export const LIST_APP_QUERY = 'LIST_APP_QUERY';
export const LIST_APP_DETAIL_QUERY = 'LIST_APP_DETAIL_QUERY';
export const LIST_APP_CATEGORIES_QUERY = 'LIST_APP_CATEGORIES_QUERY';
export const LIST_APP_RATINGS_QUERY = 'LIST_APP_RATINGS_QUERY';
export const LIST_BAU_MODULES_QUERY = 'LIST_BAU_MODULES_QUERY';

export const LIST_APP_DETAIL_PRICING_QUERY = 'LIST_APP_DETAIL_PRICING_QUERY';

export const LIST_APP_PERMISSIONS_QUERY = 'LIST_APP_PERMISSIONS_QUERY';
